import React, { useState, useEffect } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background/95 backdrop-blur-md shadow-md'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <div className="flex items-center space-x-2">
            <div className="bg-gradient-primary p-2 rounded-lg">
              <Globe className="h-5 w-5 sm:h-6 sm:w-6 text-primary-foreground" />
            </div>
            <div className="flex flex-col">
              <span className="text-base sm:text-lg font-bold text-foreground font-['Space_Grotesk']">
                VISA INTELLIGENCE
              </span>
              <span className="text-[10px] sm:text-xs text-muted-foreground -mt-1">
                Immigration Experts
              </span>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-1 lg:space-x-2">
            <Button
              variant="ghost"
              onClick={() => scrollToSection('services')}
              className="text-foreground hover:text-primary hover:bg-primary/5"
            >
              Services
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('why-us')}
              className="text-foreground hover:text-primary hover:bg-primary/5"
            >
              Why Us
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('process')}
              className="text-foreground hover:text-primary hover:bg-primary/5"
            >
              Process
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('testimonials')}
              className="text-foreground hover:text-primary hover:bg-primary/5"
            >
              Testimonials
            </Button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-primary text-primary-foreground hover:opacity-90 ml-2"
            >
              Contact Us
            </Button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6 text-foreground" />
            ) : (
              <Menu className="h-6 w-6 text-foreground" />
            )}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background/98 backdrop-blur-md border-t border-border">
          <div className="container mx-auto px-4 py-4 space-y-2">
            <Button
              variant="ghost"
              onClick={() => scrollToSection('services')}
              className="w-full justify-start text-foreground hover:text-primary hover:bg-primary/5"
            >
              Services
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('why-us')}
              className="w-full justify-start text-foreground hover:text-primary hover:bg-primary/5"
            >
              Why Us
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('process')}
              className="w-full justify-start text-foreground hover:text-primary hover:bg-primary/5"
            >
              Process
            </Button>
            <Button
              variant="ghost"
              onClick={() => scrollToSection('testimonials')}
              className="w-full justify-start text-foreground hover:text-primary hover:bg-primary/5"
            >
              Testimonials
            </Button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-gradient-primary text-primary-foreground hover:opacity-90"
            >
              Contact Us
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
